import { createContext, useContext, useMemo, useState } from 'react';

// Create a context for user data
const StoreContext = createContext();

// Custom hook for accessing user context
export const useStore = () => useContext(StoreContext);

export const StoreProvider = ({ children }) => {

    const [store, setStore] = useState({
        user: null,
        isAuthenticated: false,
        isShowSideNav: true,
        isModalOpen: false
    });

    const updateStore = (newState) => {
        setStore((prevState) => ({ ...prevState, ...newState }));
    };

    const storeValue = useMemo(() => ({ store, updateStore }), [store, updateStore]);

    return (
        <StoreContext.Provider value={storeValue}>
            {children}
        </StoreContext.Provider>
    );
};
